export enum MembersQueryKeys {
  GET_MEMBERS_LIST = 'GET_MEMBERS_LIST',
  GET_ALL_MEMBERS = 'GET_ALL_MEMBERS',
  GET_MEMBER = 'GET_MEMBER',
  GET_NOTIFICATIONS_SETTINGS = 'GET_NOTIFICATIONS_SETTINGS',
  GET_MEMBER_PREFERENCES = 'GET_MEMBER_PREFERENCES',
  GET_PROFILE_STATUS = 'GET_PROFILE_STATUS',
  GET_SKILLS_OPTIONS = 'GET_SKILLS_OPTIONS',
  GET_MEMBER_EXPERIENCE = 'GET_MEMBER_EXPERIENCE',
  GET_MEMBER_REPOSITORIES = 'GET_MEMBER_REPOSITORIES',
  GET_MEMBERS_ROLES_OPTIONS = 'GET_MEMBERS_ROLES_OPTIONS',
  VALIDATE_OFFICE_HOURS = 'VALIDATE_OFFICE_HOURS',
  GET_ROLES = 'GET_ROLES',
  GET_TOPICS = 'GET_TOPICS',
  GET_INVESTOR_SETTINGS = 'GET_INVESTOR_SETTINGS',
  GET_MEMBER_INVESTOR_SETTINGS = 'GET_MEMBER_INVESTOR_SETTINGS',
  GET_INVESTOR_TYPES = 'GET_INVESTOR_TYPES',
  GET_DEMO_DAY_SUBSCRIPTION = 'GET_DEMO_DAY_SUBSCRIPTION',
}
